import { render } from "./AddEditSalesDepartment.vue?vue&type=template&id=55383438&scoped=true"
import script from "./AddEditSalesDepartment.vue?vue&type=script&lang=js"
export * from "./AddEditSalesDepartment.vue?vue&type=script&lang=js"

import "./AddEditSalesDepartment.vue?vue&type=style&index=0&id=55383438&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55383438"]])

export default __exports__